module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start-xs student-submission-text readable-text"
  }, [_c('div', {
    ref: _vm.submission_text_ref,
    staticClass: "response-text",
    class: [{
        'pl-caption': _vm.smallFont
      },
      {
        fadeout: _vm.show_fadeout_on_text
      },
      {
        'fadeout-shortened': _vm.show_fadeout_on_text && _vm.shortenText
      } ],
    attrs: {
      "id": _vm.submission_text_ref
    },
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedPromptResponse)
    }
  }), _vm._v(" "), (_vm.show_minimize_button && !_vm.disableMinimizeText) ? _c('a', {
    staticClass: "pl-caption italics",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleMinimizeResponse.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.minimize_response_text ? 'Expand' : 'Minimize') + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3628ebe4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/submissionResponseText.vue
// module id = 1178
// module chunks = 61